export interface CorrelationsHeaderProps {
  isNewRowsOnly?: boolean;
}

export const CorrelationsHeader = ({
  isNewRowsOnly = false
}: CorrelationsHeaderProps) => (
  <thead className="font-heebo text-soClean-180 text-sm font-medium leading-tight tracking-tight">
    <tr>
      {!isNewRowsOnly && (
        <th className="py-3 pl-4 text-left font-normal">Correlation Id</th>
      )}
      <th className="py-3 pl-4 text-left font-normal">1st Position</th>
      <th className="py-3 pl-4 text-left font-normal">1st Stat Type</th>
      <th className="py-3 pl-4 text-left font-normal">1st Choice</th>
      <th className="py-3 pl-4 text-left font-normal">2nd Position</th>
      <th className="py-3 pl-4 text-left font-normal">2nd Stat Type</th>
      <th className="py-3 pl-4 text-left font-normal">2nd Choice</th>
      <th className="py-3 pl-4 text-left font-normal">Probability</th>
      <th className="py-3 pl-4 text-left font-normal">Is Same Team</th>
      <th className="py-3 pl-4 text-left font-normal">Requested By</th>
      <th className="py-3 pl-4 text-left font-normal">Approved By</th>
      {!isNewRowsOnly && (
        <>
          <th className="py-3 pl-4 text-left font-normal">Last Modfied User</th>
          <th className="py-3 pl-4 text-left font-normal">Updated At</th>
        </>
      )}
      <td />
    </tr>
  </thead>
);
